// @ts-strict-ignore
import type { Action } from 'flow/store/engine/types';
import { ActionType } from 'flow/store/engine/constants';
import type { NormalizedOutcomeName } from '~/dashboard/views/workflows/editor/components/Island/OutcomeIsland/OnIslandOutcomeNode/constants';

import { DEFAULT_OUTCOME_PRECEDENCE_INDEX, PREVIEW_OUTCOME_ACTION_NAME } from './constants';
import {
  actionHasRules,
  getActionName,
  isActionOfType,
} from '../actions';

export const getNamesOfOutcomesInWorkflow = (outcomesInWorkflow: Action[]) => (
  outcomesInWorkflow.reduce(
    (names, outcomeAction) => names.add(getActionName(outcomeAction)),
    (new Set<Action['outcome']['name']>()),
  )
);

export function getNormalizedOutcomeName(outcomeName: string): NormalizedOutcomeName {
  const normalizedOutcomeName = outcomeName.toLocaleLowerCase().trim();
  return normalizedOutcomeName as NormalizedOutcomeName;
}

// FIXME: BUILD-1377
export function getOutcomeBaseColor(outcomeName: Action['outcome']['name']): string {
  const normalizedOutcomeName = getNormalizedOutcomeName(outcomeName);

  if (normalizedOutcomeName === 'approved') return 'var(--cl-green-300)';
  if (normalizedOutcomeName === 'denied') return 'var(--cl-red-300)';
  if (normalizedOutcomeName === 'manual review') return 'var(--cl-yellow-300)';
  // for custom outcomes
  return 'var(--cl-gray-800)';
}

export function isPreviewOutcomeAction(action: Action) {
  if (!action) {
    return false;
  }

  if (!isActionOfType(action, ActionType.OUTCOME)) {
    return false;
  }

  const hasPreviewOutcomeActionName = getActionName(action) === PREVIEW_OUTCOME_ACTION_NAME;

  if (hasPreviewOutcomeActionName) {
    return true;
  }

  const hasNoRules = !actionHasRules(action);
  const hasNotDefaultPrecedenceIndex = action.outcome.precedenceIndex
    !== DEFAULT_OUTCOME_PRECEDENCE_INDEX;

  return hasNoRules && hasNotDefaultPrecedenceIndex;
}

export function isPreviewOutcomeActionComplete(outcomeAction: Action) {
  const hasName = Boolean(getActionName(outcomeAction));
  const hasRules = actionHasRules(outcomeAction);
  const hasCorrectPrecedenceIndex = outcomeAction.outcome.precedenceIndex
    !== DEFAULT_OUTCOME_PRECEDENCE_INDEX;

  return hasName && hasRules && hasCorrectPrecedenceIndex;
}
